import * as Yup from 'yup';
import { ReactElement, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { defaultForm } from '@services/ThirdPartyService';
import { FormContainer } from '@pages';
import { FormNavFooter, FormLoading } from '@components';
import { iToolTips } from '@interfaces/interfaces';
import { INVALID_DAY, INVALID_MONTH, INVALID_YEAR, INVALID_NUMERIC_FORMAT } from '@services/ErrorMessages';
import { DemoPage } from '.';

function DemoForm(): ReactElement {
  // const { path } = useRouteMatch();
  // const history = useNavigate();
  const [loading] = useState(false);
  // const [countryList, setCountryList] = useState<iCountry[]>([]);
  const [tooltips] = useState<iToolTips>({} as iToolTips);

  // useEffect(() => {
  //   const fetchData = async (): Promise<void> => {
  //     try {
  //       const [countryResults, tooltipResults] = await Promise.all([getCountryList(), getTooltips()]);
  //       setCountryList(countryResults);
  //       setTooltips(tooltipResults);
  //       setLoading(false);
  //     } catch (error) {
  //       history.push('/error');
  //     }
  //   };
  //   fetchData();
  // }, []);

  const displayErrorsCount = (c: number): void => {
    console.log(c);
  };

  const submitForm = async (_values: any): Promise<boolean> => true;

  const DemoSchema = Yup.object().shape({
    validation: Yup.string().required(INVALID_NUMERIC_FORMAT),
    testAddress: Yup.object().shape({
      LineOne: Yup.string().required(INVALID_NUMERIC_FORMAT),
      LineTwo: Yup.string(),
      Suburb: Yup.string().required(INVALID_NUMERIC_FORMAT),
      State: Yup.string().required(INVALID_NUMERIC_FORMAT),
      Postcode: Yup.string().required(INVALID_NUMERIC_FORMAT),
      Country: Yup.string().required(INVALID_NUMERIC_FORMAT),
    }),
    testDate: Yup.object().shape({
      day: Yup.string()
        .min(1)
        .max(2)
        .matches(/^[1-9]$|^[1-3][0-9]$/)
        .required(INVALID_DAY),
      month: Yup.string()
        .min(1)
        .max(2)
        .matches(/^[1-9]$|^1[0-2]$/)
        .required(INVALID_MONTH),
      year: Yup.string().length(4, INVALID_YEAR).required(INVALID_YEAR),
    }),
  });

  return (
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    <Formik initialValues={defaultForm()} validationSchema={DemoSchema} onSubmit={() => {}}>
      {({ values }) => (
        <FormContainer title="Demo Page">
          {loading && <FormLoading />}
          {!loading && (
            <Form>
              <>
                <Routes>
                  <Route path="/">
                    <DemoPage />
                  </Route>
                </Routes>
                <FormNavFooter totalPages={6} submitPage={5} submit={async () => submitForm(values)} tooltips={tooltips} displayErrorsCount={displayErrorsCount} firstPageNo={1} />
              </>
            </Form>
          )}
        </FormContainer>
      )}
    </Formik>
  );
}

export default DemoForm;
